import hymns2 from "./hymns.json.proxy.js";
export const getHymns = () => {
  return hymns2;
};
//# sourceMappingURL=getHymns.js.map
